import site from './site.json';
import { SUPPORTED_LANGUAGES } from './index';

export const SITE_URL = site.url;

export const languageUrl = (code) => `${SITE_URL}/${code}`;

export const ogImageUrl = () => `${SITE_URL}${site.ogImage}`;

// Every language advertises the other two as og:locale:alternate.
export const alternateOgLocales = (current, ogLocaleOf) =>
  SUPPORTED_LANGUAGES.map(({ code }) => code)
    .filter((code) => code !== current)
    .map(ogLocaleOf);
